import { Component } from '@angular/core';
import { FormBuilder, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-add-support',
  templateUrl: './add-support.component.html',
  styleUrls: ['./add-support.component.css']
})
export class AddSupportComponent {
 supportForm = this.fb.group({
    firstName: ['', Validators.required],
    middleName: [''],
    lastName: ['', Validators.required],
    clientType: ['', Validators.required],
    contactType: ['', Validators.required],
    company: ['', Validators.required],
    organization: ['', Validators.required],
    department: ['', Validators.required],
    supportStaff: ['', Validators.required],
    phone: ['', [Validators.required, Validators.pattern(/^[0-9 \-+()]{10,20}$/)]],
    email: ['', [Validators.required, Validators.email]],
    homePhone: ['', Validators.pattern(/^[0-9 \-+()]{10,20}$/)],
    site: ['', Validators.required],
    siteAddress: [''],
    loginId: ['', Validators.required],
    password: ['', Validators.required],
    licenseType: ['', Validators.required],
    permissionGroup: this.fb.array([], Validators.required),
    accessRestriction: [[]]
  });

  constructor(private fb: FormBuilder) {}

  get permissionGroup() {
    return this.supportForm.get('permissionGroup') as FormArray;
  }

  onCheckboxChange(e: any) {
    const group: FormArray = this.permissionGroup;
    if (e.target.checked) {
      group.push(this.fb.control(e.target.value));
    } else {
      const index = group.controls.findIndex(x => x.value === e.target.value);
      if (index !== -1) {
        group.removeAt(index);
      }
    }
  }

  onSubmit() {
    if (this.supportForm.valid) {
      console.log('Form Submitted', this.supportForm.value);
    } else {
      this.supportForm.markAllAsTouched();
    }
  }
}
